// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IManualTransactionResponseDto
 */
export interface IManualTransactionResponseDto {
    /**
     * 
     * @type {string}
     * @memberof IManualTransactionResponseDto
     */
    manual_transaction_request_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IManualTransactionResponseDto
     */
    processing_status?: IManualTransactionResponseDtoProcessingStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof IManualTransactionResponseDto
     */
    raw_data?: string;
    /**
     * 
     * @type {Date}
     * @memberof IManualTransactionResponseDto
     */
    created_at?: Date;
}

/**
* @export
* @enum {string}
*/
export enum IManualTransactionResponseDtoProcessingStatusEnum {
    PROCESSING = 'PROCESSING',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED'
}


/**
 * Check if a given object implements the IManualTransactionResponseDto interface.
 */
export function instanceOfIManualTransactionResponseDto(value: object): value is IManualTransactionResponseDto {
    return true;
}

export function IManualTransactionResponseDtoFromJSON(json: any): IManualTransactionResponseDto {
    return IManualTransactionResponseDtoFromJSONTyped(json, false);
}

export function IManualTransactionResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IManualTransactionResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'manual_transaction_request_id': json['manual_transaction_request_id'] == null ? undefined : json['manual_transaction_request_id'],
        'processing_status': json['processing_status'] == null ? undefined : json['processing_status'],
        'raw_data': json['raw_data'] == null ? undefined : json['raw_data'],
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
    };
}

export function IManualTransactionResponseDtoToJSON(json: any): IManualTransactionResponseDto {
    return IManualTransactionResponseDtoToJSONTyped(json, false);
}

export function IManualTransactionResponseDtoToJSONTyped(value?: IManualTransactionResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'manual_transaction_request_id': value['manual_transaction_request_id'],
        'processing_status': value['processing_status'],
        'raw_data': value['raw_data'],
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
    };
}

